const qaClientId = "_HFBsV9pFZfTmCQjFEJfTvfETFEa";
const prodClientId = "T4gVl526wzf8Fu6oGyKSDIlTflAa";
const baseConfig = {
    publicAPIVersion: "4.23",
    publicAPIClientType: "ServiceApp",
    assetManagementApiBaseUrl: "https://api-s.trumpf.com",
    authIssuer: "https://identity-s.trumpf.com",
    myTrumpfBaseUrl: "https://trumpf.com.cms.qa.tru",
    authClientId: qaClientId,
    authScope: "openid oicd"
};
const envConfigs = {
    dev: Object.assign(Object.assign({}, baseConfig), { publicApiBaseUrl: "https://api.qa.mytbs.trumpf.com", useMockData: false, logging: true }),
    devLegacy: Object.assign(Object.assign({}, baseConfig), { publicApiBaseUrl: "https://api.mytrumpf.com.qa.tru", useMockData: false, logging: true }),
    qa: Object.assign(Object.assign({}, baseConfig), { publicApiBaseUrl: "https://api.qa.mytbs.trumpf.com", useMockData: false }),
    qaLegacy: Object.assign(Object.assign({}, baseConfig), { publicApiBaseUrl: "https://api.mytrumpf.com.qa.tru", useMockData: false }),
    prod: Object.assign(Object.assign({}, baseConfig), { publicApiBaseUrl: "https://api.mytbs.trumpf.com", assetManagementApiBaseUrl: "https://api-p.trumpf.com", myTrumpfBaseUrl: "https://mytrumpf.com", authIssuer: "https://identity.trumpf.com", authClientId: prodClientId, useMockData: false }),
    prodLegacy: Object.assign(Object.assign({}, baseConfig), { publicApiBaseUrl: "https://api.mytrumpf.com", assetManagementApiBaseUrl: "https://api-p.trumpf.com", myTrumpfBaseUrl: "https://mytrumpf.com", authIssuer: "https://identity.trumpf.com", authClientId: prodClientId, useMockData: false })
};
let env = "prod";
const authClientName = "service-cases";
/**
 * get config for a specific environment
 * @param environment any custom env string (optional - will use env set by setEnv otherwise)
 * @returns config object
 */
const getEnvConfig = (environment) => {
    return envConfigs[environment || env];
};
/**
 * set the current environment (used for getEnvConfig)
 * @param environment any custom env string
 */
const setEnv = (environment) => {
    if (!envConfigs[environment]) {
        // eslint-disable-next-line no-console
        console.error(`Environment ${environment} not found`);
        return;
    }
    env = environment;
};

var AuthClientPersistenceOptions;
(function (AuthClientPersistenceOptions) {
    AuthClientPersistenceOptions["NONE"] = "none";
    AuthClientPersistenceOptions["LOCAL_STORAGE"] = "localStorage";
    AuthClientPersistenceOptions["SESSION_STORAGE"] = "sessionStorage";
})(AuthClientPersistenceOptions || (AuthClientPersistenceOptions = {}));
var OAuthGrantTypes;
(function (OAuthGrantTypes) {
    OAuthGrantTypes["AUTH_CODE"] = "authorization_code";
    OAuthGrantTypes["REFRESH_TOKEN"] = "refresh_token";
    OAuthGrantTypes["PASSWORD"] = "password";
})(OAuthGrantTypes || (OAuthGrantTypes = {}));
var OAuthStatusTypes;
(function (OAuthStatusTypes) {
    OAuthStatusTypes["IDLE"] = "idle";
    OAuthStatusTypes["PENDING"] = "pending";
    OAuthStatusTypes["ERROR"] = "error";
    OAuthStatusTypes["AUTHENTICATED"] = "authenticated";
})(OAuthStatusTypes || (OAuthStatusTypes = {}));

function getRegisteredGlobal(namespace, globalObj) {
    const target = (Array.isArray(namespace) ? namespace : namespace.split(".")).reduce((prev, curr) => (prev === null || prev === undefined ? undefined : prev[curr]), globalObj || (typeof window !== "undefined" ? window : global) || {});
    return typeof target === "undefined" ? undefined : target;
}

const globalNamespaceBase = "trumpf";
function registerGlobal(obj, namespace, globalObj) {
    const tree = Array.isArray(namespace) ? namespace : namespace.split(".");
    if (tree[0] !== globalNamespaceBase) {
        throw new Error("Invalid namespace");
    }
    let current = globalObj || (typeof window !== "undefined" ? window : global) || {};
    tree.forEach((part, index) => {
        if (index === tree.length - 1) {
            current[part] = obj;
        }
        else {
            current[part] = current[part] || {};
            current = current[part];
        }
    });
}

const BASE_NS = "trumpf.ux.authClient";
const DEFAULT_CLIENT_SCOPE = "global";
const DEFAULT_CLIENT_NS = BASE_NS + "." + DEFAULT_CLIENT_SCOPE;
const DEFAULT_CLIENT_PERSISTENCE = AuthClientPersistenceOptions.NONE;
const defaultAuthClientConfig = {
    namespace: DEFAULT_CLIENT_NS,
    persistenceType: DEFAULT_CLIENT_PERSISTENCE
};
const getJWTPayload = (token) => {
    if (!token?.length) {
        return null;
    }
    const base64Url = token.split(".")[1];
    if (!base64Url) {
        return null;
    }
    const base64 = base64Url.replace("-", "+").replace("_", "/");
    try {
        return JSON.parse(window.atob(base64));
    }
    catch (error) {
        return null;
    }
};
const detectTokenExpirationTime = (data) => {
    if (data.expires_at) {
        return data.expires_at;
    }
    const jwt = getJWTPayload(data.id_token || null);
    if (jwt) {
        if (typeof jwt.exp === "number") {
            return jwt.exp;
        }
        if (typeof jwt.iat === "number" && data.expires_in > 0) {
            return jwt.iat + data.expires_in;
        }
    }
    return undefined;
};

class AuthClient {
    accessToken = null;
    authData = null;
    config;
    observers = [];
    constructor(options) {
        this.config = {
            ...defaultAuthClientConfig,
            ...options
        };
        this.init();
    }
    init() {
        const { namespace } = this.config;
        const storage = this.getStorage();
        const storedValue = storage ? storage.getItem(namespace) : null;
        if (storedValue) {
            try {
                const storedData = JSON.parse(storedValue);
                if (storedData.access_token) {
                    this.accessToken = storedData.access_token;
                    this.authData = storedData;
                    const exp = detectTokenExpirationTime(storedData) || 0;
                    if (exp > 0) {
                        if (exp > Math.floor(new Date().getTime() / 1000)) {
                            this.authData.expires_at = exp;
                        }
                        else {
                            this.accessToken = null;
                            this.authData = null;
                        }
                    }
                }
            }
            catch {
            }
            this.updateStorage();
        }
    }
    getStorage() {
        if (typeof window === "undefined") {
            return null;
        }
        switch (this.config.persistenceType) {
            case AuthClientPersistenceOptions.LOCAL_STORAGE:
                return window.localStorage;
            case AuthClientPersistenceOptions.SESSION_STORAGE:
                return window.sessionStorage;
            default:
                return null;
        }
    }
    updateStorage() {
        const { namespace } = this.config;
        const storage = this.getStorage();
        if (storage === null) {
            return;
        }
        const data = this.authData ? this.authData : this.accessToken ? { access_token: this.accessToken } : null;
        if (!data?.access_token) {
            storage.removeItem(namespace);
            return;
        }
        const jsonString = JSON.stringify(data);
        storage.setItem(namespace, jsonString);
    }
    notifyObservers() {
        this.observers.forEach((observer) => {
            try {
                observer(this.accessToken);
            }
            catch {
            }
        });
    }
    getAccessToken() {
        return this.accessToken;
    }
    setAccessToken(token) {
        if (!token?.length) {
            return false;
        }
        if (token === this.accessToken) {
            return true;
        }
        this.accessToken = token;
        this.authData = null;
        this.updateStorage();
        this.notifyObservers();
        return true;
    }
    deleteAccessToken() {
        if (this.accessToken === null) {
            return;
        }
        this.accessToken = null;
        this.authData = null;
        this.updateStorage();
        this.notifyObservers();
    }
    getTokenData() {
        return this.authData;
    }
    getTokenExpiration() {
        return this.authData ? detectTokenExpirationTime(this.authData) : undefined;
    }
    setTokenData(data) {
        if (!data?.access_token || data.access_token === this.accessToken) {
            return;
        }
        this.authData = data;
        this.accessToken = data.access_token;
        if (!this.authData.expires_at) {
            const exp = detectTokenExpirationTime(data) || 0;
            if (exp > 0) {
                this.authData.expires_at = exp;
            }
        }
        this.updateStorage();
        this.notifyObservers();
    }
    getRefreshToken() {
        return this.authData ? this.authData.refresh_token || null : null;
    }
    getIdToken() {
        return this.authData ? this.authData.id_token || null : null;
    }
    getIdTokenPayload() {
        return getJWTPayload(this.getIdToken());
    }
    subscribe(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
        }
        return () => {
            this.unsubscribe(observer);
        };
    }
    unsubscribe(observer) {
        const index = this.observers.indexOf(observer);
        if (index !== -1) {
            this.observers.splice(index, 1);
        }
    }
}

function getAuthClient(scopeOrOptions) {
    let namespace = DEFAULT_CLIENT_NS;
    let persistenceType = DEFAULT_CLIENT_PERSISTENCE;
    if (scopeOrOptions) {
        if (typeof scopeOrOptions === "string") {
            namespace = BASE_NS + "." + scopeOrOptions;
        }
        else {
            if (scopeOrOptions.namespace) {
                namespace = scopeOrOptions.namespace;
            }
            else if (scopeOrOptions.globalNamespace) {
                namespace = scopeOrOptions.globalNamespace;
            }
            if (scopeOrOptions.persistenceType) {
                persistenceType = scopeOrOptions.persistenceType;
            }
        }
    }
    let client = getRegisteredGlobal(namespace, window);
    if (client === undefined) {
        client = new AuthClient({
            namespace,
            persistenceType
        });
        registerGlobal(client, namespace);
    }
    return client;
}

var TrumpfEnvNames;
(function (TrumpfEnvNames) {
    TrumpfEnvNames["PROD"] = "prod";
    TrumpfEnvNames["QA"] = "qa";
})(TrumpfEnvNames || (TrumpfEnvNames = {}));

/*! formdata-polyfill. MIT License. Jimmy W?rting <https://jimmy.warting.se/opensource> */
(function(){var h;function l(a){var b=0;return function(){return b<a.length?{done:!1,value:a[b++]}:{done:!0}}}var m="function"==typeof Object.defineProperties?Object.defineProperty:function(a,b,c){if(a==Array.prototype||a==Object.prototype)return a;a[b]=c.value;return a};
function n(a){a=["object"==typeof globalThis&&globalThis,a,"object"==typeof window&&window,"object"==typeof self&&self,"object"==typeof global&&global];for(var b=0;b<a.length;++b){var c=a[b];if(c&&c.Math==Math)return c}throw Error("Cannot find global object");}var q=n(this);function r(a,b){if(b)a:{var c=q;a=a.split(".");for(var d=0;d<a.length-1;d++){var e=a[d];if(!(e in c))break a;c=c[e];}a=a[a.length-1];d=c[a];b=b(d);b!=d&&null!=b&&m(c,a,{configurable:!0,writable:!0,value:b});}}
r("Symbol",function(a){function b(f){if(this instanceof b)throw new TypeError("Symbol is not a constructor");return new c(d+(f||"")+"_"+e++,f)}function c(f,g){this.A=f;m(this,"description",{configurable:!0,writable:!0,value:g});}if(a)return a;c.prototype.toString=function(){return this.A};var d="jscomp_symbol_"+(1E9*Math.random()>>>0)+"_",e=0;return b});
r("Symbol.iterator",function(a){if(a)return a;a=Symbol("Symbol.iterator");for(var b="Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "),c=0;c<b.length;c++){var d=q[b[c]];"function"===typeof d&&"function"!=typeof d.prototype[a]&&m(d.prototype,a,{configurable:!0,writable:!0,value:function(){return u(l(this))}});}return a});function u(a){a={next:a};a[Symbol.iterator]=function(){return this};return a}
function v(a){var b="undefined"!=typeof Symbol&&Symbol.iterator&&a[Symbol.iterator];return b?b.call(a):{next:l(a)}}var w;if("function"==typeof Object.setPrototypeOf)w=Object.setPrototypeOf;else {var y;a:{var z={a:!0},A={};try{A.__proto__=z;y=A.a;break a}catch(a){}y=!1;}w=y?function(a,b){a.__proto__=b;if(a.__proto__!==b)throw new TypeError(a+" is not extensible");return a}:null;}var B=w;function C(){this.m=!1;this.j=null;this.v=void 0;this.h=1;this.u=this.C=0;this.l=null;}
function D(a){if(a.m)throw new TypeError("Generator is already running");a.m=!0;}C.prototype.o=function(a){this.v=a;};C.prototype.s=function(a){this.l={D:a,F:!0};this.h=this.C||this.u;};C.prototype.return=function(a){this.l={return:a};this.h=this.u;};function E(a,b){a.h=3;return {value:b}}function F(a){this.g=new C;this.G=a;}F.prototype.o=function(a){D(this.g);if(this.g.j)return G(this,this.g.j.next,a,this.g.o);this.g.o(a);return H(this)};
function I(a,b){D(a.g);var c=a.g.j;if(c)return G(a,"return"in c?c["return"]:function(d){return {value:d,done:!0}},b,a.g.return);a.g.return(b);return H(a)}F.prototype.s=function(a){D(this.g);if(this.g.j)return G(this,this.g.j["throw"],a,this.g.o);this.g.s(a);return H(this)};
function G(a,b,c,d){try{var e=b.call(a.g.j,c);if(!(e instanceof Object))throw new TypeError("Iterator result "+e+" is not an object");if(!e.done)return a.g.m=!1,e;var f=e.value;}catch(g){return a.g.j=null,a.g.s(g),H(a)}a.g.j=null;d.call(a.g,f);return H(a)}function H(a){for(;a.g.h;)try{var b=a.G(a.g);if(b)return a.g.m=!1,{value:b.value,done:!1}}catch(c){a.g.v=void 0,a.g.s(c);}a.g.m=!1;if(a.g.l){b=a.g.l;a.g.l=null;if(b.F)throw b.D;return {value:b.return,done:!0}}return {value:void 0,done:!0}}
function J(a){this.next=function(b){return a.o(b)};this.throw=function(b){return a.s(b)};this.return=function(b){return I(a,b)};this[Symbol.iterator]=function(){return this};}function K(a,b){b=new J(new F(b));B&&a.prototype&&B(b,a.prototype);return b}function L(a,b){a instanceof String&&(a+="");var c=0,d=!1,e={next:function(){if(!d&&c<a.length){var f=c++;return {value:b(f,a[f]),done:!1}}d=!0;return {done:!0,value:void 0}}};e[Symbol.iterator]=function(){return e};return e}
r("Array.prototype.entries",function(a){return a?a:function(){return L(this,function(b,c){return [b,c]})}});
if("undefined"!==typeof Blob&&("undefined"===typeof FormData||!FormData.prototype.keys)){var M=function(a,b){for(var c=0;c<a.length;c++)b(a[c]);},N=function(a){return a.replace(/\r?\n|\r/g,"\r\n")},O=function(a,b,c){if(b instanceof Blob){c=void 0!==c?String(c+""):"string"===typeof b.name?b.name:"blob";if(b.name!==c||"[object Blob]"===Object.prototype.toString.call(b))b=new File([b],c);return [String(a),b]}return [String(a),String(b)]},P=function(a,b){if(a.length<b)throw new TypeError(b+" argument required, but only "+
a.length+" present.");},Q="object"===typeof globalThis?globalThis:"object"===typeof window?window:"object"===typeof self?self:this,R=Q.FormData,S=Q.XMLHttpRequest&&Q.XMLHttpRequest.prototype.send,T=Q.Request&&Q.fetch,U=Q.navigator&&Q.navigator.sendBeacon,V=Q.Element&&Q.Element.prototype,W=Q.Symbol&&Symbol.toStringTag;W&&(Blob.prototype[W]||(Blob.prototype[W]="Blob"),"File"in Q&&!File.prototype[W]&&(File.prototype[W]="File"));try{new File([],"");}catch(a){Q.File=function(b,c,d){b=new Blob(b,d||{});
Object.defineProperties(b,{name:{value:c},lastModified:{value:+(d&&void 0!==d.lastModified?new Date(d.lastModified):new Date)},toString:{value:function(){return "[object File]"}}});W&&Object.defineProperty(b,W,{value:"File"});return b};}var escape=function(a){return a.replace(/\n/g,"%0A").replace(/\r/g,"%0D").replace(/"/g,"%22")},X=function(a){this.i=[];var b=this;a&&M(a.elements,function(c){if(c.name&&!c.disabled&&"submit"!==c.type&&"button"!==c.type&&!c.matches("form fieldset[disabled] *"))if("file"===
c.type){var d=c.files&&c.files.length?c.files:[new File([],"",{type:"application/octet-stream"})];M(d,function(e){b.append(c.name,e);});}else "select-multiple"===c.type||"select-one"===c.type?M(c.options,function(e){!e.disabled&&e.selected&&b.append(c.name,e.value);}):"checkbox"===c.type||"radio"===c.type?c.checked&&b.append(c.name,c.value):(d="textarea"===c.type?N(c.value):c.value,b.append(c.name,d));});};h=X.prototype;h.append=function(a,b,c){P(arguments,2);this.i.push(O(a,b,c));};h.delete=function(a){P(arguments,
1);var b=[];a=String(a);M(this.i,function(c){c[0]!==a&&b.push(c);});this.i=b;};h.entries=function b(){var c,d=this;return K(b,function(e){1==e.h&&(c=0);if(3!=e.h)return c<d.i.length?e=E(e,d.i[c]):(e.h=0,e=void 0),e;c++;e.h=2;})};h.forEach=function(b,c){P(arguments,1);for(var d=v(this),e=d.next();!e.done;e=d.next()){var f=v(e.value);e=f.next().value;f=f.next().value;b.call(c,f,e,this);}};h.get=function(b){P(arguments,1);var c=this.i;b=String(b);for(var d=0;d<c.length;d++)if(c[d][0]===b)return c[d][1];
return null};h.getAll=function(b){P(arguments,1);var c=[];b=String(b);M(this.i,function(d){d[0]===b&&c.push(d[1]);});return c};h.has=function(b){P(arguments,1);b=String(b);for(var c=0;c<this.i.length;c++)if(this.i[c][0]===b)return !0;return !1};h.keys=function c(){var d=this,e,f,g,k,p;return K(c,function(t){1==t.h&&(e=v(d),f=e.next());if(3!=t.h){if(f.done){t.h=0;return}g=f.value;k=v(g);p=k.next().value;return E(t,p)}f=e.next();t.h=2;})};h.set=function(c,d,e){P(arguments,2);c=String(c);var f=[],g=O(c,
d,e),k=!0;M(this.i,function(p){p[0]===c?k&&(k=!f.push(g)):f.push(p);});k&&f.push(g);this.i=f;};h.values=function d(){var e=this,f,g,k,p,t;return K(d,function(x){1==x.h&&(f=v(e),g=f.next());if(3!=x.h){if(g.done){x.h=0;return}k=g.value;p=v(k);p.next();t=p.next().value;return E(x,t)}g=f.next();x.h=2;})};X.prototype._asNative=function(){for(var d=new R,e=v(this),f=e.next();!f.done;f=e.next()){var g=v(f.value);f=g.next().value;g=g.next().value;d.append(f,g);}return d};X.prototype._blob=function(){var d="----formdata-polyfill-"+
Math.random(),e=[],f="--"+d+'\r\nContent-Disposition: form-data; name="';this.forEach(function(g,k){return "string"==typeof g?e.push(f+escape(N(k))+('"\r\n\r\n'+N(g)+"\r\n")):e.push(f+escape(N(k))+('"; filename="'+escape(g.name)+'"\r\nContent-Type: '+(g.type||"application/octet-stream")+"\r\n\r\n"),g,"\r\n")});e.push("--"+d+"--");return new Blob(e,{type:"multipart/form-data; boundary="+d})};X.prototype[Symbol.iterator]=function(){return this.entries()};X.prototype.toString=function(){return "[object FormData]"};
V&&!V.matches&&(V.matches=V.matchesSelector||V.mozMatchesSelector||V.msMatchesSelector||V.oMatchesSelector||V.webkitMatchesSelector||function(d){d=(this.document||this.ownerDocument).querySelectorAll(d);for(var e=d.length;0<=--e&&d.item(e)!==this;);return -1<e});W&&(X.prototype[W]="FormData");if(S){var Y=Q.XMLHttpRequest.prototype.setRequestHeader;Q.XMLHttpRequest.prototype.setRequestHeader=function(d,e){Y.call(this,d,e);"content-type"===d.toLowerCase()&&(this.B=!0);};Q.XMLHttpRequest.prototype.send=
function(d){d instanceof X?(d=d._blob(),this.B||this.setRequestHeader("Content-Type",d.type),S.call(this,d)):S.call(this,d);};}T&&(Q.fetch=function(d,e){e&&e.body&&e.body instanceof X&&(e.body=e.body._blob());return T.call(this,d,e)});U&&(Q.navigator.sendBeacon=function(d,e){e instanceof X&&(e=e._asNative());return U.call(this,d,e)});Q.FormData=X;}})();

var SharedStoreNames;
(function (SharedStoreNames) {
    SharedStoreNames["GLOBAL"] = "global";
})(SharedStoreNames || (SharedStoreNames = {}));

class ApiClient {
    constructor(config) {
        this.token = null;
        this.authClientServiceCalls = getAuthClient(authClientName);
        this.config = config;
        this.token = this.authClientServiceCalls.getAccessToken();
        if (this.token) {
            this.onAuth();
        }
        else {
            this.authClientServiceCalls.subscribe((token) => {
                this.token = token || null;
                this.onAuth();
            });
        }
    }
    onAuth() {
        // placeholder for any action to be taken on authentication
    }
    async request(path, options) {
        if (this.config.useMockData) {
            return this.mockRequest(options === null || options === void 0 ? void 0 : options.mockResponse);
        }
        if (this.authClientServiceCalls === null) {
            return Promise.reject("AuthClient not initialized");
        }
        if (!this.token) {
            return Promise.reject("No token");
        }
        const { method = "POST", headers = {}, body, binary } = options || {};
        const response = await fetch(`${path}`, {
            method,
            headers: Object.assign({ Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${this.token}` }, headers),
            body: binary
                ? body
                : JSON.stringify(Object.assign({}, body))
        });
        if (response.status === 200) {
            if ((options === null || options === void 0 ? void 0 : options.responseType) === "blob") {
                return response.blob();
            }
            return response.json();
        }
        return Promise.reject(`Error ${response.status}`);
    }
    async mockRequest(mockResponse) {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockResponse);
            }, 1000);
        });
    }
}

const publicApiClients = {};
const getPublicApiClient = (config) => {
    const { publicApiBaseUrl, authIssuer, authScope, authClientId } = config;
    const key = `${publicApiBaseUrl}-${authIssuer}-${authScope}-${authClientId}`;
    if (!publicApiClients[key]) {
        publicApiClients[key] = new PublicApiClient(config);
    }
    return publicApiClients[key];
};
class PublicApiClient extends ApiClient {
    constructor() {
        super(...arguments);
        this.tbdbToken = null;
        this.tbdbSubscribers = [];
    }
    subscribeToTbdbToken(onTbdbToken) {
        this.tbdbSubscribers.push(onTbdbToken);
        if (this.tbdbToken) {
            onTbdbToken({ success: true });
        }
        return () => {
            this.tbdbSubscribers = this.tbdbSubscribers.filter((subscriber) => subscriber !== onTbdbToken);
        };
    }
    /**
     * Request function to send an authenticated POST request to the PublicAPI
     */
    async request(path, options) {
        if (this.config.useMockData) {
            return this.mockRequest(options === null || options === void 0 ? void 0 : options.mockResponse);
        }
        if (this.authClientServiceCalls === null) {
            return Promise.reject(new Error("AuthClient not initialized"));
        }
        if (!this.tbdbToken) {
            return Promise.reject(new Error("No TBDB token"));
        }
        const { method = "POST", headers = {}, body, binary, responseType } = options || {};
        const tokenForBinary = binary ? { TbdbToken: this.tbdbToken } : {};
        const response = await fetch(`${this.config.publicApiBaseUrl}${path}`, {
            method,
            headers: Object.assign(Object.assign({ Accept: "application/json", "Content-Type": "application/json" }, tokenForBinary), headers),
            body: binary
                ? body
                : JSON.stringify(Object.assign(Object.assign({}, body), { token: this.tbdbToken }))
        });
        if (response.status === 200) {
            return responseType === "blob" ? response.blob() : response.json();
        }
        if (response.status === 401) {
            this.authClientServiceCalls.deleteAccessToken();
            throw new Error("Unauthorized");
        }
        throw new Error(`${(await response.text()) || response.status}`);
    }
    onAuth() {
        this.requestTbdbToken()
            .then((token) => {
            this.tbdbToken = token;
            this.tbdbSubscribers.forEach((subscriber) => {
                subscriber({ success: true });
            });
        })
            .catch((error) => {
            const errorMessage = `Error while fetching tbdb token: ${error}`;
            // eslint-disable-next-line no-console
            console.error(errorMessage);
            this.tbdbSubscribers.forEach((subscriber) => {
                subscriber({ success: false, errorMessage });
            });
        });
    }
    async requestTbdbToken() {
        const { publicApiBaseUrl, publicAPIVersion, publicAPIClientType, useMockData } = this.config;
        if (useMockData) {
            return this.mockRequest("mockToken");
        }
        return fetch(`${publicApiBaseUrl}/user/createticket`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${this.token}`
            },
            body: JSON.stringify({
                clientType: publicAPIClientType,
                apiVersion: publicAPIVersion
            })
        })
            .then((response) => {
            if (response.status === 401) {
                return Promise.reject("Unauthorized");
            }
            return response.json();
        })
            .then((data) => data.token);
    }
}

export { ApiClient as A, PublicApiClient as P, getAuthClient as a, authClientName as b, getPublicApiClient as c, getEnvConfig as g, setEnv as s };

//# sourceMappingURL=publicApiClient-f3b890c3.js.map